import { render, staticRenderFns } from "./voteDetail.vue?vue&type=template&id=00acb106&scoped=true&"
import script from "./voteDetail.vue?vue&type=script&lang=js&"
export * from "./voteDetail.vue?vue&type=script&lang=js&"
import style0 from "./voteDetail.vue?vue&type=style&index=0&id=00acb106&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00acb106",
  null
  
)

export default component.exports